import React, { useEffect, useState } from "react";
import NewsletterSection from "components/NewsletterSection/NewsletterSection";
import HeroSection from "./HeroSection";
import SectionLatestPosts from "./SectionLatestPosts";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import { BlogPost } from "data/types";

const BlogPage: React.FC = () => {
  const [latestPosts, setLatestPosts] = useState<BlogPost[]>([]);
  const [tags, setTags] = useState<any[]>([]);
  const [popular, setPopular] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const base = process.env.REACT_APP_API_URL;
    Promise.all([
      fetch(`${base}/posts/latest`).then(r => r.json()),
      fetch(`${base}/posts/tags`).then(r => r.json()),
      fetch(`${base}/posts/popular`).then(r => r.json()),
    ])
      .then(([latest, tags, popular]) => {
        setLatestPosts(latest);
        setTags(tags);
        setPopular(popular);
      })
      .catch(err => console.error("Failed to fetch home data:", err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="nc-BlogPage overflow-hidden relative">
      <BgGlassmorphism />
      <div className="container relative">
        <HeroSection tags={tags} />
        <SectionLatestPosts
          className="py-16 lg:py-28"
          latestPosts={latestPosts}
          tags={tags}
          popular={popular}
          loading={loading}
        />
        <NewsletterSection className="pb-16 lg:pb-28" />
      </div>
    </div>
  );
};

export default BlogPage;
